import type { SlotPlanInfo, DisplayWeekDay } from '@@partner:types:app'
import type { GroupedSlotPlans } from './types'

export const WEEK_DAYS: DisplayWeekDay[] = [
  { label: 'Понедельник', value: 1 },
  { label: 'Вторник', value: 2 },
  { label: 'Среда', value: 3 },
  { label: 'Четверг', value: 4 },
  { label: 'Пятница', value: 5 },
  { label: 'Суббота', value: 6 },
  { label: 'Воскресенье', value: 0 },
]

export const groupByWeekDay = (items: SlotPlanInfo[]) =>
  items.reduce<GroupedSlotPlans>((prev, curr) => ({
    ...prev,
    [curr.weekDay]: ([] as SlotPlanInfo[]).concat(prev[curr.weekDay] ?? [], curr)
  }), {} as GroupedSlotPlans)

